// extracted by mini-css-extract-plugin
export default {"container":"WSStars-module_container-FF4x6","stars":"WSStars-module_stars-n_i4b","star":"WSStars-module_star-J9g8M"};